import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import type { ReactNode } from "react";

interface StepNoticeProps {
  id?: string;
  /** A refusal that keeps the step from continuing (credit limit, credits that expire first). */
  blocking?: boolean;
  /** `alert` (default) is the wine notice; `neutral` is for news that asks nothing of the user. */
  tone?: "alert" | "neutral";
  children: ReactNode;
}

/** Background and text colours per tone; neutral is the import review's skipped-rows note. */
const TONE_CLASSES = {
  alert: "bg-good-wine-4 text-good-wine",
  neutral: "bg-light-dust text-rodeo-black",
} as const;

/**
 * The prototype's `.cx-amend-note is-alert`: a sentence the user has to act on, shared by every
 * Add Recipients step. Its own module, so the steps that show it never import one another (F11).
 */
export default function StepNotice({
  id,
  blocking = false,
  tone = "alert",
  children,
}: StepNoticeProps) {
  const Icon = blocking ? BlockOutlinedIcon : InfoOutlinedIcon;
  return (
    <div
      id={id}
      role="alert"
      className={[
        "flex items-start gap-2 rounded-lg px-3.5 py-2.5 text-[13px] leading-[1.45]",
        TONE_CLASSES[tone],
      ].join(" ")}
    >
      <Icon sx={{ fontSize: 18, flexShrink: 0, mt: "1px" }} />
      <p>{children}</p>
    </div>
  );
}
